import { ChatSessionsData } from 'core_main/api/sessions/types';
import { ConversationCallbackResponse } from '../types';

export const createGetConversationCallbackResponse = (
  session: ChatSessionsData,
): ConversationCallbackResponse => {
  const { id: conversationId } = session;
  const { createdAt, preview, lastMessageAt, lockedAt } = session.attributes;

  return {
    conversationId,
    createdAt,
    preview,
    lastMessageAt,
    ended: !!lockedAt,
  };
};
